import { render, staticRenderFns } from "./EmployeeIsp.vue?vue&type=template&id=6337f24b&lang=pug&"
import script from "./EmployeeIsp.vue?vue&type=script&lang=js&"
export * from "./EmployeeIsp.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeIsp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployeeIsp.vue"
export default component.exports